<template>
    <div>
        <b-row align-h="center">
            <b-col cols="auto">
                <app-title
                    :text="`Bienvenido a ${accessPoint.client.name}`"
                ></app-title>
            </b-col>
        </b-row>
        <div v-if="!!entry">
            <app-person-entry-card
                :entry="entry"
                v-if="entryType === 'person'"
            ></app-person-entry-card>
            <app-vehicle-entry-card
                :entry="entry"
                v-else
            ></app-vehicle-entry-card>
        </div>
        <div v-else>
            <b-row align-h="center">
                <b-col cols="auto">
                    <app-clock :size="20"></app-clock>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import appPersonEntryCard from '@components/UI/Vigilance/Realtime/PersonEntryCard'
import appVehicleEntryCard from '@components/UI/Vigilance/Realtime/VehicleEntryCard'
import appClock from '@components/UI/Controls/Clock/Clock'
export default {
    components: {
        appPersonEntryCard,
        appVehicleEntryCard,
        appClock,
    },
    data: () => ({
        entry: null,
        entryType: '',
        timeOut: null,
    }),
    methods: {
        listeners() {
            // TODO: Enable when pusher is ready
            // Echo.channel(`AccessPoint.${this.accessPoint.id}`)
            //     .listen('.PersonEntryRegistered', (e) =>
            //         this.entryRegistered(e.entry, 'person')
            //     )
            //     .listen('.VehicleEntryRegistered', (e) =>
            //         this.entryRegistered(e.entry, 'vehicle')
            //     )
        },
        entryRegistered(entry, type) {
            !!this.timeOut && clearTimeout(this.timeOut)
            this.entryType = type
            this.entry = entry
            this.timeOut = setTimeout(() => {
                this.entry = null
            }, 1000 * 60 * 2)
        },
    },
    created() {
        this.listeners()
    },
}
</script>

<style></style>
